import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

export const baseAPiVersion = 'api/v1';

export const API_CONFIG = {
	path: {
		login: 'auth',
		register: 'account',
		emailVerification: 'account/verify',
		passwordRecovery: 'account/forgot',
		resetPassword: 'account/reset',
		contest: 'contest',
		updatePicks: 'contest/make-picks',
		sportsList: 'sports',
		leaguesList: 'leagues',
		matchesList: 'matches',
		globalConfig: 'configuration',
		me: 'account/me',
		accountDetails: 'account/edit',
		changePassword: 'account/change-password',
		avatarPreSignedUrl: 'account/avatar-pre-signed-url',
		invitation: 'contest-invitation',
		viewContest: 'contest/view',
		contestDetails: 'contest/details',
		withDraw: 'wallet/withdraw',
		transactionHistory: 'wallet/transaction',
		authTrack: 'auth/track',
		rewards: 'users/winning'
	}
};

export const getUrl = (url: string, params: any = {}): string => {
	Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);
	let urlString = `${url}`;
	if (params && !isEmpty(params)) {
		urlString += `?${queryString.stringify(params)}`;
	}
	return urlString;
};
